var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("br"),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("H1", { staticClass: "pageTitle isPoppins" }, [
          _vm._v("Frequently Asked Questions")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "top15 accSettingsForm aboutText" }, [
          _c("div", { staticClass: "question" }, [
            _vm._v("\n            What are slinks?\n        ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "answer" }, [
            _vm._v(
              "\n            Slinks are words or short phrases that when triggered by entering them into a web browser address bar prefaced by the \"slink.com/\" domain, automatically redirect the browser to \n            a URL of the slink owners choosing. E.g. we have setup the slink 'music' to redirect the browser to 'https://en.wikipedia.org/wiki/music'.  You can try this by entering the following into a browser or \n            clicking on it:  "
            ),
            _c(
              "a",
              {
                staticClass: "has-text-warning",
                attrs: { href: "https://slink.com/music" }
              },
              [_c("b", [_vm._v("slink.com/music")])]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "question" }, [
            _vm._v("\n            Why use slinks?\n        ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "answer" }, [
            _vm._v(
              "\n            There are many reasons why slinks are useful. Slinks are easy to remember alternatives to complicated URLs and the use of intuitive words that are related to the underlying\n            URL destination you are trying to drive traffic to, will make it much easier for your audiences to reach you. If you owned the slink 'chocolate' and your company sells chocolate, \n            it would be much easier for your potential customers to find you using the slink, rather than remembering your actual company name or webpage domain. Short, intuitive domain names\n            themselves are difficult or expensive to get. Slinks serve as a meta-layer to simplify driving traffic. Additionally, many social platforms prevent the clicking of URLs in posts. By\n            providing them with a slink instead, your readers can easily reach the URL you would like them to visit by entering the slink prefaced by 'slink.com/' into their browser. You can also use slinks to redirect to email addresses, social media profiles, \n            digital wallets, online videoconference meeting id's and any other service that can be reached via a URL. \n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "question" }, [
            _vm._v(
              "\n            How easily and often can I change the URL my slinks redirect to? How long does it take for the change to reflect?\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "answer" }, [
            _vm._v(
              '\n            It is very easy to change the target URL of a slink. You can do this from the "Manage Services" option in the "My Account" menu, once you are logged in.\n            You can change the targt URL of your slinks as often as you like. The change reflects immediately.\n        '
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "question" }, [
            _vm._v("\n            What are subslinks?\n        ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "answer" }, [
            _vm._v(
              "\n            A subslink is an extension of a slink that has its own independent redirection URL.  So subslink of the slink 'music' might be 'music:guitar'. A colon followed by another word is used to\n            extend the root slink word.  So while the slink music will redirect to one URL, the subslink music:guitar can redirect to an entirely different on. Once you have obtained a slink, you have the right to control any subslinks\n            derived from it. Each slink you purchase comes bundled with the option to create a number of subslinks. You will be able to upgrade to plans with higher subslink counts.\n            You can manage your slink's subslinks from the \"Manage Services\" option in the \"My Account\" menu, once you are logged in.\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "question" }, [
            _vm._v("\n            How long do subscriptions last?\n        ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "answer" }, [
            _vm._v(
              "\n            Everything you purchase on the Slink website is on a yearly subcription basis. The subscription will renew automatically unless you cancel it.  Each product purchased \n            has it's own billing cycle.\n            If billing fails on the renewal date, you will have a short grace period to provide an alternaate payment mechanism, after which your slinks will be removed from your account\n            and become available for others to purchase.\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "question" }, [
            _vm._v(
              "\n            What about brand names or words and phrases protected by trademarks?\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "answer" }, [
            _vm._v(
              "\n            A trademark gives its owner exclusive right to the use of a protected word or phrase. If you know a word or phrase is a trademark and you do not own that trademark, do\n            not attempt to purchase it as a slink. We reserve the right to remove a trademarked slink from your account, if the rightful trademark owner files a succesful claim. For more information,\n            please refer to our Terms and Conditions.\n        "
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br")
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a064122", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a064122","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FAQ.vue
// module id = null
// module chunks = 